import { createFileRoute } from "@tanstack/react-router";
import { OverviewPage } from "@/features/overview/overview-page";

export const Route = createFileRoute("/_authenticated/overview/")({
  head: () => ({ meta: [{ title: "Overview · Rogue Admin" }] }),
  component: OverviewPage,
});
